import React from 'react';
import SimpleEditorComponent from '../../../components/simple-editor';

const SimpleEditor = (props) => (
  <SimpleEditorComponent {...props}/>
)

export default SimpleEditor;
